var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "btn",
    {
      attrs: { type: _vm.type, size: _vm.size, disabled: _vm.loading },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("div", { staticClass: "text-wrapper" }, [
        _c(
          "div",
          { style: { visibility: _vm.loading ? "hidden" : "visible" } },
          [
            _vm.icon
              ? _c("i", {
                  class: `fa fa-${_vm.icon}`,
                  attrs: { "aria-hidden": "true" },
                })
              : _vm._e(),
            _vm._v("\n            " + _vm._s(_vm.text) + "\n        "),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "spinner-wrapper" }, [
          _vm.loading
            ? _c("i", {
                staticClass: "fa fa-spinner fa-spin text-center",
                attrs: { "aria-hidden": "true" },
              })
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }